const DEFAULT_SOURCE = 'signal';
const DEFAULT_MEDIUM = 'web';

const normalizePathname = (pathname = '/') =>
  pathname === '' ? '/' : pathname.replace(/([^:]\/)\/+/g, '$1');

const applyDefaults = (params) => {
  if (!params.has('utm_source')) params.set('utm_source', DEFAULT_SOURCE);
  if (!params.has('utm_medium')) params.set('utm_medium', DEFAULT_MEDIUM);
};

const mergeParams = (location, extraParams = {}, preserveExisting = true) => {
  const params =
    preserveExisting && location?.search
      ? new URLSearchParams(location.search)
      : new URLSearchParams();
  applyDefaults(params);
  Object.entries(extraParams).forEach(([key, value]) => {
    if (value === undefined || value === null) {
      params.delete(key);
    } else {
      params.set(key, value);
    }
  });
  return params;
};

export const stripHash = (hashValue = '') =>
  hashValue.startsWith('#') ? hashValue.slice(1) : hashValue;

export const buildUtmLink = ({
  pathname = '/',
  location,
  utmCampaign,
  extraParams = {},
  hash,
  preserveExisting = true,
}) => {
  const params = mergeParams(location, extraParams, preserveExisting);
  if (utmCampaign) {
    params.set('utm_campaign', utmCampaign);
  }
  const search = params.toString();
  const normalizedHash = hash ? `#${stripHash(hash)}` : '';
  return `${normalizePathname(pathname)}${search ? `?${search}` : ''}${normalizedHash}`;
};

export const getUtmDebugAttributes = (location, overrides = {}) => {
  const params = mergeParams(location, {}, true);
  const source = overrides.source || params.get('utm_source') || DEFAULT_SOURCE;
  const medium = overrides.medium || params.get('utm_medium') || DEFAULT_MEDIUM;
  const campaign = overrides.campaign || params.get('utm_campaign');
  const attrs = {
    'data-utm-source': source,
    'data-utm-medium': medium,
  };
  if (campaign) {
    attrs['data-utm-campaign'] = campaign;
  }
  return attrs;
};

export const getAnchorFromLocation = (location) => stripHash(location?.hash || '');